import { useEffect, useState } from 'react';
import Game from './components/Game';
import Settings from './components/Settings';
import useColorScheme from './hooks/colorScheme';
import './App.scss';

type Config = {
    id: string,
    b: 4 | 5,
    m: 'drag' | 'select'
};
type PuzzleResult = {p: number, s: number};

const App = (): JSX.Element => {
    const [config, setConfig] = useState<Config>(JSON.parse(atob(localStorage.getItem('config') || 'e30=')));
    const { isDark, setScheme } = useColorScheme();

    useEffect(() => {
        const eventListener = (event: StorageEvent | CustomEvent): void => {
            if (event instanceof StorageEvent && event.key === 'config' && event.newValue) {
                if (typeof event.newValue === 'object') {
                    setConfig(event.newValue);
                } else {
                    setConfig(JSON.parse(atob(event.newValue)));
                }
            } else if (event instanceof CustomEvent && event.detail.key && event.detail.key === 'config' && event.detail.newValue) {
                setConfig(event.detail.newValue);
            }
        };

        window.addEventListener('storage', eventListener);

        return () => window.removeEventListener('storage', eventListener);
    }, []);

    if (! config || ! config.b || ![4, 5].includes(config.b) || ! config.m || !['drag', 'select'].includes(config.m) || ! config.id) {
        return <Settings config={config} modal={false} />
    }

    return <Game config={config} isDark={isDark} setScheme={setScheme} />
}

export default App;
